const SAFE_ANALYTICS_QUERY_KEYS = new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id",
  "gclid",
  "fbclid",
  "event",
  "mode",
  "tab",
  "open_tasks",
  "ref",
  "source",
  "surface",
]);

export function sanitizeAnalyticsSearch(search = "") {
  const input = new URLSearchParams(String(search || ""));
  const output = new URLSearchParams();

  input.forEach((value, key) => {
    const normalizedKey = String(key || "").trim().toLowerCase();
    if (SAFE_ANALYTICS_QUERY_KEYS.has(normalizedKey)) {
      output.append(normalizedKey, value);
    }
  });

  const serialized = output.toString();
  return serialized ? `?${serialized}` : "";
}

export function hasUnsafeAnalyticsQuery(search = "") {
  const input = new URLSearchParams(String(search || ""));
  let unsafe = false;
  input.forEach((_, key) => {
    if (!SAFE_ANALYTICS_QUERY_KEYS.has(String(key || "").trim().toLowerCase())) {
      unsafe = true;
    }
  });
  return unsafe;
}

export function getAnalyticsPagePath(locationLike) {
  const source =
    locationLike || (typeof window !== "undefined" ? window.location : null) || {};
  return `${source.pathname || "/"}${sanitizeAnalyticsSearch(source.search)}`;
}

export function getAnalyticsPageLocation(locationLike) {
  const source =
    locationLike || (typeof window !== "undefined" ? window.location : null) || {};
  const origin = source.origin || (typeof window !== "undefined" ? window.location.origin : "");
  return `${origin}${getAnalyticsPagePath(source)}`;
}
